module.exports = __webpack_public_path__ + "img/apple_pie_remonce.db99e492.jpg";